import React, { useState } from 'react';
import { Card, CardHeader, CardBody, Collapse } from 'reactstrap';
import { UpOutlined, DownOutlined } from '@ant-design/icons';

const Header = data => {
  const [toggleQuestion, setToggequestion] = useState(1);

  return (
    <div className="nf-u-details__grid">
      {data.block[0].value && (
        <Card className="nf-solicitation-detail__card">
          <CardHeader
            className="nf-solicitation-detail__card-header"
            onClick={() => setToggequestion(!toggleQuestion)}
          >
            Packaging Info
            {toggleQuestion ? <UpOutlined /> : <DownOutlined />}
          </CardHeader>
          <Collapse isOpen={toggleQuestion}>
            <CardBody>{data.block[0].value}</CardBody>
          </Collapse>
        </Card>
      )}

      {/* <Table dataSource={drawings} columns={columns} /> */}
    </div>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./src/pages/universalDetails/niinDetailTables/pkgInfo.jsx